import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n  position: absolute;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '@acorns/web-components';
import { NavDirection } from './types';
var Container = styled.div(_templateObject());
var NavButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onPress = _ref.onPress,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref
  }, /*#__PURE__*/React.createElement(Button, {
    type: "mini",
    onPress: onPress
  }, children));
});
export var Pagination = function Pagination(_ref2) {
  var prevButtonRef = _ref2.prevButtonRef,
      nextButtonRef = _ref2.nextButtonRef,
      handleNav = _ref2.handleNav,
      showNext = _ref2.showNext,
      showPrev = _ref2.showPrev;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", null, showPrev && /*#__PURE__*/React.createElement(NavButton, {
    ref: prevButtonRef,
    onPress: function onPress() {
      return handleNav(NavDirection.PREV);
    }
  }, "Prev")), /*#__PURE__*/React.createElement("div", null, showNext && /*#__PURE__*/React.createElement(NavButton, {
    ref: nextButtonRef,
    onPress: function onPress() {
      return handleNav(NavDirection.NEXT);
    }
  }, "Next")));
};